<script>
	// Stores 
	import { textSite, linkWhatsappCondominio, linkAV, linkConheca, mailProposta } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader	from "../components/PageHeader.svelte";

   	// Code	
	let titlePage = 'Administração de Condomínios ';

	let items = [
		{
			icon: 'fas fa-chart-line',
			title: 'Assessoria Financeira',
			text: '<p>Planejamento Financeiro, Acompanhamento das Movimentações Financeiras, Emissão e Cobrança das Cotas Condominiais Através de Docs. Apresentação Mensal dos Balancetes e Extrato de Conta Corrente. Recebimento das cotas condominiais na Imobiliária sem o custo da taxa bancária.</p>'
		},
		{
			icon: 'fas fa-file-invoice-dollar',
			title: 'Controle de Inadimplência',
			text: '<p>Comunicação dos condôminos inadimplentes, ingresso de ação de cobrança mediante autorização do síndico, ação de cobrança ajuizada perante justiça comum.</p>'
		},
		{
			icon: 'fas fa-balance-scale',
			title: 'Departamento Jurídico',
			text: '<p>A disposição do síndico(a) para qualquer esclarecimento, dúvida parecer, pertinente ao condomínio, e nas relações interpessoais com os moradores, proprietários e inquilinos. </p>'
		},
		{
			icon: 'fas fa-users',
			title: 'Assessoria de Pessoal',
			text: '<p>Administração Geral dos Funcionários do Condomínio – Admissões, Pagamentos e Demissões.</p>'
		},
		{
			icon: 'fas fa-briefcase',
			title: 'Secretaria',
			text: '<p>Confecção e Envio de Correspondências, Circulares, Atas, etc., Orçamentação e Aquisição de Materiais e Serviços de Manutenção. Pagamentos a Fornecedores de Segunda a Sexta-Feira no horário Comercial. </p>'
		},
		{
			icon: 'fas fa-phone-laptop',
			title: 'Aplicativo Digital',
			text: '<p>Permite acesso às informações como: financeiro, boletos, documentos, avisos, reservas do condomínio, comunicação de lista de convidados ao síndico, recebimento e envio de mensagens, tudo em um único lugar, com acesso pelo seu celular, tablet ou computador.</p>'
		},
	];

</script>

<PageHeader title={titlePage} buttons=""></PageHeader>

<div class="container">
	<p class="text-center">
		Estamos prontos para assessorar as melhores soluções para o seu condomínio, confira os serviços:
	</p>

	<div class="grid grid-size--1 grid-size-sm--1">
		<div class="grid grid-size--3 grid-size-md--2 grid-size-sm--1 gap-20 text-center">
			{#each items as item, i}
			<div class="item background-gray round-all pa-20">
				<div class="flex flex-center">
					<div class="background-accent color-white circle r-75"><i class="{item.icon} fa-2x"></i></div>
				</div>
				<h5 class="text-bold pt-20">{item.title}</h5>
				<p>{@html item.text}</p>
			</div>
			{/each}
		</div>
		<hr>
		<p class="text-center">
			Venha conhecer nossa empresa ou solicite-nos uma proposta.
		</p>
		<div class="button text-center">        
			<a href="/solicite-proposta" use:link replace title="" class="btn btn-secondary">
				SOLICITE UMA PROPOSTA <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
			</a>
		</div>
	</div>
</div>